import { useState, useRef, useEffect, useCallback } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdfjs/pdf.worker.min.mjs`;

const LunchMenuPages = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [width, setWidth] = useState(800);
  const containerRef = useRef(null);

  const updateWidth = useCallback(() => {
    const el = containerRef.current;
    if (el) setWidth(el.clientWidth);
  }, []);

  useEffect(() => {
    updateWidth();
    const el = containerRef.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(updateWidth);
    ro.observe(el);
    return () => ro.disconnect();
  }, [updateWidth]);

  return (
    <div ref={containerRef} className="menu-pdf-pages">
      <Document
        file={fileUrl}
        onLoadSuccess={({ numPages: n }) => setNumPages(n)}
        loading={<p className="menu-pdf-status">Loading menu…</p>}
        error={<p className="menu-pdf-status">Could not load menu.</p>}
      >
        {numPages
          ? Array.from({ length: numPages }, (_, i) => (
              <Page
                key={i + 1}
                pageNumber={i + 1}
                width={width}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                className="menu-pdf-page"
              />
            ))
          : null}
      </Document>
    </div>
  );
};

export default LunchMenuPages;
